import { render, staticRenderFns } from "./EditGradualMessage.vue?vue&type=template&id=2edcd4b4&"
import script from "./EditGradualMessage.vue?vue&type=script&lang=js&"
export * from "./EditGradualMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports